import { Pipe, PipeTransform } from '@angular/core';
import { OpportunityStage } from '@shared/types/opportunity-stage';

@Pipe({
  name: 'opportunityStage',
  standalone: false,
})
export class OpportunityStagePipe implements PipeTransform {
  transform(value: OpportunityStage): string {
    switch (value) {
      case 'qualification':
        return 'Qualification';
      case 'poc_demo':
        return 'POC/Demo';
      case 'proposal':
        return 'Proposal';
      case 'negotiation':
        return 'Final Negotiation';
      case 'won':
        return 'Won';
      case 'lost':
        return 'Lost';
      case 'closed':
        return 'Closed';
      default:
        return value;
    }
  }
}
